import './ButtonLoading.scss';

import React, { forwardRef, useMemo } from 'react';

import Button from '@/common/components/atoms/Button/Button';
import Spinner from '@/common/components/atoms/Spinner/Spinner';

import {
  ButtonLoadingDefaultProps,
  ButtonLoadingPropTypes,
} from './ButtonLoading.proptypes';

const ButtonLoading = forwardRef(
  (
    {
      buttonSize,
      children,
      className,
      context,
      disabled,
      fontSize,
      isLoading,
      onClick,
      type,
      value,
      variant,
      withIcon,
    },
    ref,
  ) => {
    const classNames = useMemo(
      () =>
        [
          'button-loading',
          isLoading ? 'button-loading--loading' : null,
          className,
        ]
          .filter((val) => val)
          .join(' '),
      [className, isLoading],
    );

    return (
      <Button
        buttonSize={buttonSize}
        className={classNames}
        context={context || 'button-loading'}
        disabled={disabled || isLoading}
        fontSize={fontSize}
        onClick={onClick}
        ref={ref}
        type={type}
        value={value}
        variant={variant}
        withIcon={withIcon}
        /* eslint-disable-next-line react/jsx-props-no-spreading */
        {...(value ? { value } : null)}
      >
        {isLoading && <Spinner />}
        <span
          className={`button__content${
            isLoading ? ' button__content--hidden' : ''
          }`}
        >
          {children}
        </span>
      </Button>
    );
  },
);

ButtonLoading.defaultProps = {
  ...ButtonLoadingDefaultProps,
};

ButtonLoading.propTypes = {
  ...ButtonLoadingPropTypes,
};

export default ButtonLoading;
